const PosData = [
  {
    cardData: {
      img: "/assets/media/svg/food-icons/spaghetti.svg",
      title: "Lunch",
      numOfOptions: 8,
    },
    categoriesInCard: [
      {
        img: "/assets/media/stock/food/img-9.jpg",
        title: "Beaf Stew (Kabab Halla) - كباب حلة (Person...",
        time: "16",
        price: "15",
      },
      {
        img: "/assets/media/stock/food/img-1.jpg",
        title: "Chicken Alfredo - دجاج ألفريدو",
        time: "20",
        price: "12",
      },
      {
        img: "/assets/media/stock/food/img-2.jpg",
        title: "Grilled Salmon - سلمون مشوي",
        time: "25",
        price: "20",
      },
      {
        img: "/assets/media/stock/food/img-3.jpg",
        title: "Vegetable Stir Fry - خضار مشوح",
        time: "18",
        price: "10",
      },
      {
        img: "/assets/media/stock/food/img-4.jpg",
        title: "Beef Burger - برجر بيف",
        time: "15",
        price: "8",
      },
      {
        img: "/assets/media/stock/food/img-5.jpg",
        title: "Caesar Salad - سلطة سيزر",
        time: "10",
        price: "6",
      },
      {
        img: "/assets/media/stock/food/img-6.jpg",
        title: "Margherita Pizza - بيتزا مارجريتا",
        time: "20",
        price: "14",
      },
      {
        img: "/assets/media/stock/food/img-7.jpg",
        title: "Spaghetti Bolognese - سباجيتي بولونيز",
        time: "22",
        price: "13",
      },
      {
        img: "/assets/media/stock/food/img-8.jpg",
        title: "Chicken Shawarma - شاورما دجاج",
        time: "15",
        price: "9",
      }
    ],
  },
  {
    cardData: {
      img: "/assets/media/svg/food-icons/salad.svg",
      title: "Salad",
      numOfOptions: 14,
    },
    categoriesInCard: [
      {
        img: "/assets/media/stock/food/img-9.jpg",
        title: "Soup of the Day",
        time: "16",
        price: "7.50",
      },
      {
        img: "/assets/media/stock/food/img-4.jpg",
        title: "Chicken Breast",
        time: "16",
        price: "9.00",
      },
      {
        img: "/assets/media/stock/food/img-3.jpg",
        title: "A special salad",
        time: "16",
        price: "13.00",
      },
    ],
  },
  {
    cardData: {
      img: "/assets/media/svg/food-icons/cheeseburger.svg",
      title: "Burger",
      numOfOptions: 5,
    },
    categoriesInCard: [
      {
        img: "/assets/media/stock/food/img-4.jpg",
        title: "Chicken Breast",
        time: "16",
        price: "9.00",
      },
      {
        img: "/assets/media/stock/food/img-8.jpg",
        title: "Ramen",
        time: "16",
        price: "14.90",
      },
    ],
  },
  {
    cardData: {
      img: "/assets/media/svg/food-icons/coffee.svg",
      title: "Coffee",
      numOfOptions: 7,
    },
    categoriesInCard: [
      {
        img: "/assets/media/stock/food/img-11.jpg",
        title: "Sweetey",
        time: "16",
        price: "11.40",
      },
      {
        img: "/assets/media/stock/food/img-8.jpg",
        title: "Ramen",
        time: "16",
        price: "14.90",
      },
    ],
  },
  {
    cardData: {
      img: "/assets/media/svg/food-icons/cheesecake.svg",
      title: "Dessert",
      numOfOptions: 8,
    },
    categoriesInCard: [
      {
        img: "/assets/media/stock/food/img-11.jpg",
        title: "Sweetey",
        time: "16",
        price: "11.40",
      },
      {
        img: "/assets/media/stock/food/img-2.jpg",
        title: "T-Bone Stake",
        time: "16",
        price: "16.50",
      },
    ],
  },
  {
    cardData: {
      img: "/assets/media/svg/food-icons/spaghetti.svg",
      title: "Sushi",
      numOfOptions: 10,
    },
    categoriesInCard: [
      {
        img: "/assets/media/stock/food/img-7.jpg",
        title: "Salmon Nigiri",
        time: "12",
        price: "8.00",
      },
      {
        img: "/assets/media/stock/food/img-6.jpg",
        title: "Tuna Roll",
        time: "15",
        price: "10.00",
      },
    ],
  },
  {
    cardData: {
      img: "/assets/media/svg/food-icons/cheeseburger.svg",
      title: "Steak",
      numOfOptions: 6,
    },
    categoriesInCard: [
      {
        img: "/assets/media/stock/food/img-5.jpg",
        title: "Ribeye Steak",
        time: "30",
        price: "25.00",
      },
      {
        img: "/assets/media/stock/food/img-4.jpg",
        title: "Filet Mignon",
        time: "25",
        price: "28.00",
      },
    ],
  },
  {
    cardData: {
      img: "/assets/media/svg/food-icons/cheesecake.svg",
      title: "Pasta",
      numOfOptions: 12,
    },
    categoriesInCard: [
      {
        img: "/assets/media/stock/food/img-1.jpg",
        title: "Fettuccine Alfredo",
        time: "20",
        price: "15.00",
      },
      {
        img: "/assets/media/stock/food/img-2.jpg",
        title: "Penne Arrabbiata",
        time: "18",
        price: "12.00",
      },
    ],
  },
  {
    cardData: {
      img: "/assets/media/svg/food-icons/coffee.svg",
      title: "Coffee2",
      numOfOptions: 5,
    },
    categoriesInCard: [
      {
        img: "/assets/media/stock/food/img-3.jpg",
        title: "Chocolate Ice Cream",
        time: "5",
        price: "4.00",
      },
      {
        img: "/assets/media/stock/food/img-4.jpg",
        title: "Chocolate Ice Cream",
        time: "5",
        price: "4.00",
      },
    ],
  },
];

export { PosData };
